module.exports = __webpack_public_path__ + "static/media/greenbook_popup.a02d42e9.jpg";